import React from 'react';
import { Box, Divider } from '@mui/material';
import MarkdownRenderer from './MarkdownRenderer';
import EnhancedSkeleton from './EnhancedSkeleton';

const SummaryTabContent = ({ 
  summary, 
  isStreaming, 
  streamingChunkSummaries, 
  expectedChunks 
}) => {
  return (
    <>
      {/* 개선된 렌더링 방식: 처음부터 최종요약 + divider + 청크별요약 skeleton을 모두 생성 */}
      {isStreaming ? (
        // 스트리밍 중: 처음부터 모든 영역을 skeleton으로 생성
        <>
          {/* 최종요약 영역 - 항상 맨 위에 위치 */}
          {summary ? (
            // 최종요약이 생성되면 실제 내용 표시
            <MarkdownRenderer content={summary} />
          ) : (
            // 최종요약 생성 중이면 스켈레톤 표시
            <Box sx={{ mb: 2 }}>
              <EnhancedSkeleton variant="text" height={24} width="80%" animationType="power-pulse" sx={{ mb: 1 }} />
              <EnhancedSkeleton variant="text" height={20} width="100%" animationType="enhanced-wave" sx={{ mb: 1 }} />
              <EnhancedSkeleton variant="text" height={20} width="90%" animationType="shimmer" sx={{ mb: 1 }} />
              <EnhancedSkeleton variant="text" height={20} width="85%" animationType="gradient-flow" sx={{ mb: 1 }} />
              <EnhancedSkeleton variant="text" height={20} width="70%" animationType="rainbow-wave" />
            </Box>
          )}
          
          {/* Divider - 항상 표시 */}
          <Divider sx={{ my: 3 }} />
          
          {/* 청크별 요약 영역 - 동적으로 렌더링 */}
          {(() => {
            // 실제 청크 수와 예상 청크 수를 비교하여 더 정확한 렌더링
            const actualChunks = streamingChunkSummaries.length;
            const renderChunks = Math.max(expectedChunks, actualChunks);
            
            return Array.from(new Array(renderChunks)).map((_, index) => (
              <Box key={`chunk-${index}`} sx={{ mb: 2 }}>
                {streamingChunkSummaries[index] ? (
                  // 해당 청크가 생성되면 실제 내용 표시
                  <MarkdownRenderer content={streamingChunkSummaries[index]} />
                ) : (
                  // 아직 생성되지 않은 청크는 스켈레톤 표시 (단, 실제 청크 수를 초과하지 않는 경우에만)
                  index < expectedChunks && (
                    <Box>
                      <EnhancedSkeleton variant="text" height={20} width="90%" animationType="shimmer" sx={{ mb: 1 }} />
                      <EnhancedSkeleton variant="text" height={20} width="100%" animationType="enhanced-wave" sx={{ mb: 1 }} />
                      <EnhancedSkeleton variant="text" height={20} width="85%" animationType="gradient-flow" sx={{ mb: 1 }} />
                      <EnhancedSkeleton variant="text" height={20} width="70%" animationType="power-pulse" />
                    </Box>
                  )
                )}
              </Box>
            ));
          })()}
        </>
      ) : (
        // 스트리밍 완료 후: 실제 데이터 표시
        <>
          {/* 최종요약문 */}
          {summary && (
            <>
              <MarkdownRenderer content={summary} />
              <Divider sx={{ my: 3 }} />
            </>
          )}
          
          {/* 청크별 요약 */}
          {streamingChunkSummaries && streamingChunkSummaries.length > 0 && (
            streamingChunkSummaries.map((chunkSummary, index) => (
              <Box key={`chunk-${index}`} sx={{ mb: 2 }}>
                <MarkdownRenderer content={chunkSummary} />
              </Box>
            ))
          )}
        </>
      )}
    </>
  );
};

export default SummaryTabContent; 